module.exports = __webpack_public_path__ + "img/drop_heart.2628208e.png";